import { Stepper, Step, StepLabel } from "@mui/material";
import React from "react";

export const DPAProgressStepper = ({
  activeStep,
  writingOnly = false,
}: {
  activeStep: number;
  writingOnly?: boolean;
}) => {
  return (
    <>
      <Stepper activeStep={activeStep} className="stepper" alternativeLabel>
        <Step key="writing" active={activeStep === 0}>
          <StepLabel>Write DPA</StepLabel>
        </Step>
        {!writingOnly && (
          <Step key="addParties" active={activeStep === 1}>
            <StepLabel>Add Parties</StepLabel>
          </Step>
        )}
        {!writingOnly && (
          <Step key="gatherSignatures" active={activeStep === 2}>
            <StepLabel>Gather Signatures</StepLabel>
          </Step>
        )}
      </Stepper>
    </>
  );
};
